/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */

import $ from 'jquery';

document.addEventListener('DOMContentLoaded', function () {
  const $singlePost = $('body.single-post');

  if ($singlePost.length != 0) {
    $singlePost
      .find('.single-post__right')
      .find('h4.single-post__section-title:first-of-type')
      .text('More Articles');
  }

  $('.dealer-modal-footer').each(function() {
    $(this).text('© Carpages.ca (div. of Autopath Technologies Inc.).');
  })

});
